import { useState, type FormEvent } from 'react';
import { supabase } from '../lib/supabase';
import { t } from '../lib/sprache';
import { Logo } from '../ui/logo';

export default function PasswortSetzen({ titel, fertig }: { titel: string; fertig: () => void }) {
  const [passwort, setPasswort] = useState('');
  const [wiederholung, setWiederholung] = useState('');
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  const gueltig = passwort.length >= 12 && passwort === wiederholung;

  async function senden(e: FormEvent) {
    e.preventDefault();
    if (!gueltig) return;
    setLaeuft(true);
    setFehler(null);
    const { error } = await supabase.auth.updateUser({ password: passwort });
    setLaeuft(false);
    if (error) return setFehler(error.message);
    window.history.replaceState(null, '', window.location.pathname);
    fertig();
  }

  return (
    <main className="anmelden zentriert">
      <form className="karte anmelde-karte" onSubmit={senden} data-tour="passwort-formular">
        <Logo hoehe={32} />
        <h1>{titel}</h1>
        <p className="leise">{t('Lege dein Passwort fest. Mindestens 12 Zeichen.')}</p>
        <label className="feld">
          <span>{t('Neues Passwort')}</span>
          <input className="eingabe" type="password" autoComplete="new-password" required value={passwort} onChange={(e) => setPasswort(e.target.value)} />
        </label>
        <label className="feld">
          <span>{t('Passwort wiederholen')}</span>
          <input className="eingabe" type="password" autoComplete="new-password" required value={wiederholung} onChange={(e) => setWiederholung(e.target.value)} />
        </label>
        {wiederholung && passwort !== wiederholung && <p className="fehler">{t('Die Passwörter stimmen nicht überein.')}</p>}
        {fehler && <p className="fehler">{fehler}</p>}
        <button className="kn kn-primaer" type="submit" disabled={!gueltig || laeuft}>{laeuft ? t('Wird gespeichert …') : t('Passwort speichern')}</button>
      </form>
    </main>
  );
}
